import { User } from 'toolbandi-ui-lib';
import { Component, OnInit } from '@angular/core';
import { Login, AuthService, SharedDataService, MessageService, AuthConfig, Staff } from 'elbuild-ui-lib-core';
import { Router } from '@angular/router';

@Component({
	selector: 'app-login',
	templateUrl: './login.component.html',
	styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

	logindata: Login = new Login();
	message: string;
	loggedUser: User;
	email: string;

	showRecoverpwd: boolean = true;

	constructor(private authService: AuthService,
		private sharedDataService: SharedDataService,
		private router: Router,
		private messageService: MessageService) {
		this.sharedDataService.currentLoggedUser.subscribe(u => {
			if (this.loggedUser) {
				this.router.navigateByUrl('/starter');
			}
		});
	}

	ngOnInit() {
		console.log('login init');
		if (this.loggedUser) {
			this.router.navigateByUrl('/starter');
		}
	}

	login() {
		if (this.logindata.password && this.logindata.username) {
			this.authService.login(this.logindata).subscribe(data => {
				this.loggedUser = data as User;
				if (false) {// (false && this.loggedUser.needchangepassword) {
					this.router.navigateByUrl(`/change-password`);
					return;
				} else {
					this.router.navigateByUrl(`/`);
				}
			}, ({ error }) => {
				this.messageService.sendError(error, 'Login');
			});
		}
	}

	resetpwd() {
		this.authService.resetPassword(this.email).subscribe(result => {
			this.messageService.sendSuccess(result.msg, 'Reset password');
		}, ({ error }) => {
			this.messageService.sendError(error, 'Reset password');
		});
	}

}
